// extracted by mini-css-extract-plugin
export default {"root":"Demo_root__Na5mS"};